module.exports = __webpack_public_path__ + "img/cast_ic_mapping.b8c8a2f7.svg";